export const END_POINTS = {
  AUTH: {
    LOGIN: "auth/admin/login",
    ADMIN_PROFILE: "admin/profile",
    ADMIN_CONTROLS: "admin/admin-controls",
  },
  DASHBOARD: "admin/dashboard",
  USERS: {
    LIST: "admin/users",
    TOGGLE_STATUS: (id: string) => `admin/user/toggle/status/${id}`,
    UPDATE_USER: (id: string) => `admin/user/${id}`,
  },
  DISTRIBUTE_MONTHLY_COMMISSION: "admin/distribute-monthly-comission",
  REWARD: {
    CREATE: "admin/level",
    GET: "admin/level",
    EDIT_LEVEL: (id: string) => `admin/level/edit/${id}`,
    DELETE_LEVEL: (id: string) => `admin/level/${id}`,
  },
  DEPOSIT: {
    DEPOSITS_LIST: "admin/deposit-request",
    TOGGLE_DEPOSIT: (id: string) => `admin/deposit-request/status/${id}`,
  },
  WITHDRAW: {
    WITHDRAW_LIST: "admin/withdrawal-request",
    TOGGLE_WITHDRAW: (id: string) => `admin/withdrawal-request/status/${id}`,
  },
  CURRENCY: {
    CURRENCY_LIST: "admin/currency-chain",
    CREATE_CURRENCY: "admin/currency-chain",
    DELETE_CURRENCY_ADDRESS: (chainId: string, addressId: string) =>
      `admin/currency-chain/address/${chainId}/${addressId}`,
    ADD_CURRENCY_ADDRESS: (id: string) => `admin/currency-chain/address/${id}`,
  },
  GIFT_CLAIM: {
    LIST: "admin/claimed-levels",
  },
};
